(() => {
  if (!customElements.get('vn-announcement')) {
    class VnAnnouncement extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.vn-topbar__msg'));
        if (this.items.length < 2) return;

        this.index = Math.max(0, this.items.findIndex((item) => item.classList.contains('is-active')));
        this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
        this.autoplay = this.dataset.autoplay === 'true';

        this.querySelectorAll('[data-dir]').forEach((button) => {
          button.addEventListener('click', () => this.go(this.index + (button.dataset.dir === 'next' ? 1 : -1), true));
        });
        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.play());
        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.play();
        });

        this.onVisibility = () => (document.hidden ? this.pause() : this.play());
        this.onBlockSelect = (event) => {
          const index = this.items.indexOf(event.target);
          if (index === -1) return;
          this.editorLocked = true;
          this.pause();
          this.go(index);
        };
        this.onBlockDeselect = () => {
          this.editorLocked = false;
          this.play();
        };
        document.addEventListener('visibilitychange', this.onVisibility);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.play();
      }

      disconnectedCallback() {
        this.pause();
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      play() {
        this.pause();
        if (!this.autoplay || this.editorLocked || document.hidden) return;
        this.timer = setInterval(() => this.go(this.index + 1), this.speed);
      }

      pause() {
        clearInterval(this.timer);
      }

      go(target, restart = false) {
        const count = this.items.length;
        const next = (target + count) % count;
        if (next === this.index) return;

        const current = this.items[this.index];
        const incoming = this.items[next];

        this.setState(current, false);
        current.classList.add('is-leaving');
        clearTimeout(current.vnLeaveTimer);
        current.vnLeaveTimer = setTimeout(() => current.classList.remove('is-leaving'), 700);

        clearTimeout(incoming.vnLeaveTimer);
        incoming.classList.remove('is-leaving');
        this.setState(incoming, true);

        this.index = next;
        if (restart) this.play();
      }

      setState(item, active) {
        item.classList.toggle('is-active', active);
        if (active) {
          item.removeAttribute('aria-hidden');
        } else {
          item.setAttribute('aria-hidden', 'true');
        }
        const link = item.querySelector('a');
        if (!link) return;
        if (active) {
          link.removeAttribute('tabindex');
        } else {
          link.setAttribute('tabindex', '-1');
        }
      }
    }

    customElements.define('vn-announcement', VnAnnouncement);
  }

  if (!customElements.get('vn-mega-menu')) {
    class VnMegaMenu extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-vn-mega-card]'));
        if (this.cards.length < 2) return;

        this.active = '0';
        const onIntent = (event) => {
          const trigger = event.target.closest('[data-vn-mega-index]');
          if (trigger && this.contains(trigger)) this.show(trigger.dataset.vnMegaIndex);
        };
        this.addEventListener('pointerover', onIntent);
        this.addEventListener('focusin', onIntent);
      }

      show(index) {
        if (this.active === index) return;
        this.active = index;
        this.cards.forEach((card) => card.classList.toggle('is-active', card.dataset.vnMegaCard === index));
      }
    }

    customElements.define('vn-mega-menu', VnMegaMenu);
  }

  if (window.vnHeaderHoverBound) return;
  window.vnHeaderHoverBound = true;

  const canHover = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  const selector = '.header__inline-menu details[data-vn-hover]';
  let hoverTimer;

  const setOpen = (details, open) => {
    if (details.open === open) return;
    details.open = open;
    details.vnHoverOpenedAt = open ? Date.now() : 0;
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', open);
  };

  document.addEventListener('pointerover', (event) => {
    if (!canHover.matches || event.pointerType !== 'mouse') return;
    const details = event.target.closest && event.target.closest(selector);
    if (!details) return;
    clearTimeout(hoverTimer);
    if (details.open) return;
    hoverTimer = setTimeout(() => {
      document.querySelectorAll(`${selector}[open]`).forEach((other) => {
        if (other !== details) setOpen(other, false);
      });
      setOpen(details, true);
    }, 90);
  });

  document.addEventListener('pointerout', (event) => {
    if (!canHover.matches || event.pointerType !== 'mouse') return;
    const details = event.target.closest && event.target.closest(selector);
    if (!details || details.contains(event.relatedTarget)) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(() => setOpen(details, false), 220);
  });

  document.addEventListener(
    'click',
    (event) => {
      if (!canHover.matches || event.detail === 0) return;
      const summary = event.target.closest && event.target.closest(`${selector} > summary`);
      if (!summary) return;
      const details = summary.parentElement;
      if (!details.open || !details.vnHoverOpenedAt) return;
      event.preventDefault();
      if (summary.dataset.vnHref) window.location.href = summary.dataset.vnHref;
    },
    true
  );
})();
